import { array, number, object, string } from "yup";

const notRequired = {
  date: string().notRequired(),
  description: string().notRequired(),
  amount: string().notRequired(),
};

const required = (lockDate?: string) => ({
  date: string()
    .required()
    .test("date after locked date", "Invalid date", (value) => {
      if (!value) return false;
      if (!lockDate) return true;

      const date = new Date(value);
      const lockDateObj = new Date(lockDate);
      return date >= lockDateObj;
    }),
  description: string().required(),
  amount: string().required(),
});

export const manuallyTransactionsSchema = (lockDate?: string) => () =>
  object().shape({
    transactions: array().of(
      object().when({
        is: (value: Record<string, string>) => {
          return Object.entries(value).every(([key, value]) =>
            key === "id" || key === "amount" ? true : !value
          );
        },
        then: object(notRequired),
        otherwise: object(required(lockDate)),
      })
    ),
  });
